import { Box, Dialog, DialogContent, IconButton, Grid, Typography, styled } from "@mui/material"
import AppButton from "components/StyledComponents/AppButton"
import AppSelect from "components/StyledComponents/AppSelect"
import { Formik } from "formik"
import React, { useEffect, useState } from "react"
import { validationSchemaTriviaMonth } from "helpers/validationSchema"
import styles from "../../../PendingQuestionTable.module.scss"
import CloseIcon from "@mui/icons-material/Close"
import { useDispatch, useSelector } from "react-redux"
import { useHistory } from "react-router-dom"
import { addQuestionToChallengeAction, getWeeklyChallengeAction } from "redux/marketing/actions"

const StyledDialog = styled(Dialog)(() => ({
  "& .MuiPaper-root": {
    backgroundColor: "transparent"
  }
}))

const AddToChallenge = ({ onClose = () => {}, data = {} }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { weeklyChallengeList } = useSelector((state) => state?.marketing)
  const [months, setMonths] = useState([])

  const handleSubmit = (values) => {
    const payload = {
      ...data,
      weekly_challenge: values?.month
    }

    const handleRoute = () => {
      history.push("/learning_development/dashboard/weekly-challenge")
    }
    dispatch(addQuestionToChallengeAction({ payload: payload, handleRoute: handleRoute }))
    onClose()
  }

  useEffect(() => {
    dispatch(getWeeklyChallengeAction({ status: "Draft", include_future: true }))
  }, [])

  useEffect(() => {
    let resData = []
    if (weeklyChallengeList?.length > 0) {
      for (let i of weeklyChallengeList) {
        resData.push({
          value: i.id,
          label: i.name
        })
      }
    }
    setMonths(resData)
  }, [weeklyChallengeList])

  return (
    <StyledDialog open={true} maxWidth="">
      <DialogContent id="editQuestionDialog" className={styles.addChallengeDialogBox}>
        <Formik
          initialValues={[]}
          validationSchema={validationSchemaTriviaMonth}
          enableReinitialize={true}
          onSubmit={handleSubmit}>
          {(formik) => (
            <React.Fragment>
              <Box className="d-flex justify-content-center position-relative">
                <Typography variant="h2" className="my-3">
                  Add Questionnaire
                </Typography>
                <Box className={styles.closeButton}>
                  <span role="button" onClick={onClose}>
                    <IconButton sx={(theme) => ({ color: theme.palette.text.primary })}>
                      <CloseIcon sx={{ height: "14px", width: "14px" }} />
                    </IconButton>
                  </span>
                </Box>
              </Box>
              <Box height={40} />
              <Box sx={{ padding: "0 11px" }}>
                <Grid container justifyContent="center" spacing={2}>
                  <Grid item xs={6}>
                    <AppSelect
                      id="month"
                      name="month"
                      menuItems={months}
                      label="Weekly Challenge"
                      isRequired={true}
                      value={formik.values.month}
                      onChange={formik.handleChange}
                    />
                  </Grid>
                </Grid>
                <Box className="d-flex justify-content-center">
                  <AppButton
                    className="mt-3 px-5"
                    variant="outlined"
                    disabled={formik.values.month ? false : true}
                    onClick={formik.handleSubmit}>
                    Save
                  </AppButton>
                </Box>
              </Box>
            </React.Fragment>
          )}
        </Formik>
      </DialogContent>
    </StyledDialog>
  )
}

export default AddToChallenge
